import { FormConfig } from '../../utils/DayMonthBaseForm';

/**
 * Formulario de configuración del rango de temporada para las porciones de frío.
 * El modelo Fishman no usa temperatura base; reutilizamos el DayMonthBaseForm
 * (que tiene su campo de temperatura opcional) para mantener el mismo estilo
 * visual que el resto de los gráficos de clima.
 */
const FORM_CONFIGS: FormConfig[] = [
  {
    title: 'Configuración Serie Porciones de Frío',
    startMonthField: 'chillPortionsStartMonth',
    startDayField: 'chillPortionsStartDay',
    endMonthField: 'chillPortionsEndMonth',
    endDayField: 'chillPortionsEndDay',
  },
];

export default FORM_CONFIGS;
